module.exports = __webpack_public_path__ + "88c5ef059d4b2e42e78519f406ab3f3d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-user/copy-accounts/copy-accounts.html
// module id = 1824
// module chunks = 0